/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Chandler Bing',
        title: 'Dispatch Services',
        text: "Great experience with Hamza on building my personal website could've never been easier than this.",
        image: boy2
    },
    {
        id: 2,
        name: 'Monica Geller',
        title: 'Head Chef',
        text: "The website perfectly captures my culinary vision—streamlining orders, showcasing my menu beautifully, and elevating my food service experience for every customer.",
        image: girl2
    },
    {
        id: 3,
        name: 'Ghazal Syed',
        title: 'Software Developer',
        text: "Hamza is a really talented and skilled web developer, who has a great eye for design and user experience. He is also very responsive and easy to work with.",
        image: girl1
    },
    {
        id: 4,
        name: 'Joey Tribbiani',
        title: 'IOT product designer',
        text: "Their expertise turned our IoT concept into a reliable, efficient product with seamless performance and real-world impact.",
        image: boy1
    },
    {
        id: 5,
        name: 'Zeeshan Ahmed',
        title: 'CTO DeliSoft',
        text: 'Realy an hopeful experience with Hamza helped us in dealing with our companies CRS. thank you guys.',
        image: boy3
    },
    {
        id: 6,
        name: 'Ross Geller',
        title: 'Paleontologist',
        text: "A great experience in creating a portal system for my customers record. ",
        image: girl3
    }
]

